import { Link } from 'react-router-dom';
import { siteContent } from '@/mocks/pt/siteContent';
import { categories, mainSiteUrl } from '@/mocks/pt/categories';

export default function Footer() {
  const { footer } = siteContent;

  return (
    <footer className="bg-primary-900 text-background-100">
      {/* Decorative background pattern */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03]">
          <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-accent-500 blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-accent-400 blur-3xl"></div>
        </div>

        <div className="relative px-4 md:px-6 py-14 md:py-16">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              {/* Brand */}
              <div className="flex-shrink-0 lg:w-72">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center">
                    <i className="ri-file-list-3-line text-base text-white"></i>
                  </div>
                  <span className="text-lg font-semibold text-white">
                    cssbuyspreadsheet
                  </span>
                  <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                </div>

                {/* Newsletter - using form */}
                <form
                  className="mb-5"
                  data-readdy-form="true"
                  id="footer-newsletter-form"
                  action="https://readdy.ai/api/form/d8votl6s51g94qljs140"
                  method="POST"
                >
                  <div className="flex">
                    <input
                      type="email"
                      name="email"
                      placeholder="Seu email para novidades"
                      className="flex-1 px-4 py-2.5 text-sm bg-primary-800/60 border border-primary-700/50 rounded-l-lg text-white placeholder:text-foreground-400 outline-none focus:border-accent-500/60 transition-colors"
                    />
                    <button
                      type="submit"
                      className="px-4 py-2.5 bg-accent-500 hover:bg-accent-600 text-white rounded-r-lg transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-notification-3-line text-base w-5 h-5 flex items-center justify-center"></i>
                    </button>
                  </div>
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
                </form>

                <p className="text-sm text-foreground-300 leading-relaxed">
                  {footer.tagline}
                </p>
              </div>

              {/* Links */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 flex-1">
                {/* Categorias */}
                <div>
                  <h4 className="text-xs font-semibold text-background-400 tracking-wider mb-4">{footer.columns.categorias.title}</h4>
                  <ul className="space-y-3">
                    {categories.slice(0, 4).map((cat) => (
                      <li key={cat.id}>
                        <a
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                        >
                          {cat.namePt}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Recursos */}
                <div>
                  <h4 className="text-xs font-semibold text-background-400 tracking-wider mb-4">{footer.columns.recursos.title}</h4>
                  <ul className="space-y-3">
                    <li>
                      <Link to="/artigo/guia-cssbuy-spreadsheet" className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer">
                        Guia SEO
                      </Link>
                    </li>
                    <li>
                      <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer">
                        Links Verificados
                      </a>
                    </li>
                    <li>
                      <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer">
                        Comparativos
                      </a>
                    </li>
                  </ul>
                </div>

                {/* Legal */}
                <div>
                  <h4 className="text-xs font-semibold text-background-400 tracking-wider mb-4">{footer.columns.legal.title}</h4>
                  <ul className="space-y-3">
                    {footer.columns.legal.links.map((link, i) => (
                      <li key={i}>
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                        >
                          {link.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Contato */}
                <div>
                  <h4 className="text-xs font-semibold text-background-400 tracking-wider mb-4">{footer.columns.contato.title}</h4>
                  <ul className="space-y-3">
                    {footer.columns.contato.links.map((link, i) => (
                      <li key={i}>
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                        >
                          {link.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Bottom bar */}
            <div className="mt-12 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                {footer.copyright}
              </p>

              {/* Social icons */}
              <div className="flex items-center gap-3">
                {['ri-instagram-line', 'ri-twitter-x-line', 'ri-youtube-line', 'ri-tiktok-line'].map((icon, i) => (
                  <a
                    key={i}
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="w-8 h-8 rounded-lg border border-primary-700/50 flex items-center justify-center text-background-300 hover:text-white hover:border-accent-500/50 transition-all cursor-pointer"
                  >
                    <i className={`${icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
                  </a>
                ))}
              </div>

              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer"
              >
                Política de Privacidade
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

